<div class="processing-status-models">

  <sc-master-detail [selection]="[selectedModel]" [data]="models" (selectionChanged)="onSelectionChanged($event);" [newStyle]="true"
    (addEntry)="onAddEntry($event);" [showDelete]="false" (deleteEntry)="onDeleteEntry($event);">

    <form #statusModelForm="ngForm" class="form">
      <div class="processing-status-model-details" *ngIf="workingCopyDetails">
        <div class="scrollable">
          <div class="form-box">
            <sc-dictionary-field [model]="workingCopyDetails.name" [defaultLabel]="'name'"
              (dictionaryChanged)="onDictionaryChanged()"
              [labelDictionaryKey]="'tmc-yard.widgets.processing-status-models.name'" [required]="true"
              [maxlength]="255">
            </sc-dictionary-field>
            <mat-form-field>
              <input [(ngModel)]="workingCopyDetails.key" name="key" matInput
                placeholder="{{'key' | translate: ['tmc-yard.widgets.processing-status-models.key', translationService.language]}}"
                [required]="true" [maxlength]="255" />
            </mat-form-field>
            <mat-form-field>
              <input [(ngModel)]="workingCopyDetails.index" name="index" matInput
                placeholder="{{'index' | translate: ['tmc-yard.widgets.processing-status-models.index', translationService.language]}}"
                [required]="true" type="number" />
            </mat-form-field>
            <mat-checkbox [(ngModel)]="workingCopyDetails.deactivated" name="deactivated">
              {{'deactivated' | translate: ['tmc-yard.widgets.processing-status-models.deactivated',
              translationService.language]}}
            </mat-checkbox>
          </div>

          <h2 class="mat-h2 processing-status-title">
            {{'Processing status' | translate: ['tmc-yard.widgets.processing-status-models.status.title',
            translationService.language]}}
          </h2>

          <div class="form-box" cdkDropList (cdkDropListDropped)="drop($event)">
            <ng-container *ngFor="let status of workingCopyDetails.processingStatus">
              <div class="draggable-form-box grid" cdkDrag *ngIf="!status.deleted">

                <mat-form-field style="grid-column: 1; grid-row: 1;">
                  <input matInput [(ngModel)]="status.key" name="key" name="{{'status_'+status.id+'_key'}}"
                    placeholder="{{'key' | translate: ['tmc-yard.widgets.processing-status-models.status.key', translationService.language]}}"
                    required [readonly]="isLoading">
                </mat-form-field>

                <div style="grid-column: 2; grid-row: 1;">
                  <sc-dictionary-field [model]="status.name" [defaultLabel]="'name'"
                    (dictionaryChanged)="onDictionaryChanged()"
                    [labelDictionaryKey]="'tmc-yard.widgets.processing-status-models.status.name'" [required]="false"
                    [maxlength]="255">
                  </sc-dictionary-field>
                </div>

                <mat-form-field style="grid-column: 3; grid-row: 1;">
                  <app-color-picker (colorSelected)="colorPickerChanged($event)" [(ngModel)]="status.color"
                    name="{{'status_'+status.id+'_color'}}"
                    placeholder="{{'color' | translate: ['tmc-yard.entity.processing-status.color', translationService.language]}}">
                  </app-color-picker>
                </mat-form-field>

                <div style="grid-column: 1; grid-row: 2;">
                  <sc-dictionary-field [model]="status.backward" [defaultLabel]="'backward'"
                    (dictionaryChanged)="onDictionaryChanged()"
                    [labelDictionaryKey]="'tmc-yard.widgets.processing-status-models.status.backward'"
                    [required]="false" [maxlength]="255">
                  </sc-dictionary-field>
                </div>

                <div style="grid-column: 2 / span 2; grid-row: 2;">
                  <sc-dictionary-field [model]="status.forward" [defaultLabel]="'forward'"
                    (dictionaryChanged)="onDictionaryChanged()"
                    [labelDictionaryKey]="'tmc-yard.widgets.processing-status-models.status.forward'" [required]="false"
                    [maxlength]="255">
                  </sc-dictionary-field>
                </div>

                <div class="centered" style="grid-column: 4; grid-row: 1">
                  <i cdkDragHandle class="fa-light fa-bars drag-handle"></i>
                </div>

                <div style="grid-column: 4; grid-row: 2" class="centered">
                  <button mat-flat-button class="small-button remove-button" (click)="removeStatus(status)"
                    [disabled]="isLoading"><sc-icon iconClass="fa-minus"></sc-icon></button>
                </div>
              </div>
            </ng-container>
            <div class="add-button-wrapper">
              <button class="add-button" mat-flat-button (click)="addStatus()" [disabled]="isLoading"><i
                  class="fa-light fa-plus"></i></button>
            </div>
          </div>
        </div>

      </div>
    </form>

    <ng-template masterDetailToolbar>
      <button mat-stroked-button class="config-changed-button" (click)="cancel()" [disabled]="!cancelEnabled">{{'cancel'
        |
        translate:
        ['tmc-yard.widgets.processing-status-models.action.cancel', translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button class="config-changed-button" (click)="save()" [disabled]="!saveEnabled">{{'save' |
        translate: ['tmc-yard.widgets.processing-status-models.action.save',
        translationService.language]}}</button>
    </ng-template>

  </sc-master-detail>

</div>
